const aboutLinks = [
    { name: "Status", link: "/status" },
    { name: "Careers", link: "/careers" },
    { name: "Terms & Conditions", link: "/terms" },
    { name: "Privacy Policy", link: "/privacy" },
    { name: "Contact Us", link: "/contact" },
  ];

  const productLinks = [
    { name: "What's New", link: "/whats-new" },
    { name: "Why GAINSS", link: "/why-testsigma" },
    { name: "Features", link: "/features" },
    { name: "Integrations", link: "/integrations" },
    { name: "Pricing", link: "/pricing" },
  ];

  const communityLinks = [
    { name: "Github", link: "https://github.com" },
    { name: "Discussions", link: "/discussions" },
    { name: "Community Home", link: "/community" },
    { name: "Discord", link: "https://discord.com" },
    { name: "Add-ons Marketplace", link: "/marketplace" },
  ];

  const guidesLinks = [
    { name: "Regression Testing", link: "/guides/regression-testing" },
    { name: "Codeless Testing", link: "/guides/codeless-testing" },
    { name: "API Testing", link: "/guides/api-testing" },
    { name: "Data Driven Testing", link: "/guides/data-driven-testing" },
    { name: "Automated Testing", link: "/guides/automated-testing" },
    { name: "Mobile Testing", link: "/guides/mobile-testing" },
    { name: "Cross Browser Testing", link: "/guides/cross-browser-testing" },
    { name: "Continuous Testing", link: "/guides/continuous-testing" },
    { name: "Parallel Testing", link: "/guides/parallel-testing" },
  ];

  const resourcesLinks = [
    { name: "Case Studies", link: "/resources/case-studies" },
    { name: "Docs", link: "/resources/docs" },
    { name: "Tutorials", link: "/resources/tutorials" },
    { name: "Blogs", link: "/resources/blogs" },
    { name: "Webinars", link: "/resources/webinars" },
    { name: "Write For Us", link: "/resources/write-for-us" },
    { name: "Free Tools", link: "/resources/free-tools" },
  ];

  const alternativesLinks = [
    { name: "TestProject Alternatives", link: "/alternatives/testproject" },
    { name: "Postman Alternatives", link: "/alternatives/postman" },
    { name: "Puppeteer Alternatives", link: "/alternatives/puppeteer" },
    { name: "Appium Alternatives", link: "/alternatives/appium" },
    { name: "Playwright Alternatives", link: "/alternatives/playwright" },
    { name: "Selenium Alternatives", link: "/alternatives/selenium" },
    { name: "Lambdatest Alternatives", link: "/alternatives/lambdatest" },
    { name: "Browserling Alternatives", link: "/alternatives/browserling" },
    { name: "Zephyr Alternatives", link: "/alternatives/zephyr" },
  ];

  const topFeatures = [
    { name: "Automated Cross Browser Testing", link: "/features/cross-browser" },
    { name: "Automated Website Testing", link: "/features/website-testing" },
    { name: "Automated Mobile App Testing", link: "/features/mobile-app-testing" },
    { name: "Automated API Testing", link: "/features/api-testing" },
    { name: "Automated Regression Testing", link: "/features/regression-testing" },
    { name: "Automated Data Driven Testing", link: "/features/data-driven-testing" },
    { name: "AI Driven Test Automation", link: "/features/ai-test-automation" },
    { name: "Automated Continuous Testing", link: "/features/continuous-testing" },
    { name: "Automated Visual Testing", link: "/features/visual-testing" },
    { name: "Automated Salesforce Testing", link: "/features/salesforce-testing" },
  ];

  const topSoftwareTools = [
    { name: "Automated Cross Browser Testing", link: "/features/cross-browser" },
    { name: "Automated Website Testing", link: "/features/website-testing" },
    { name: "Automated Mobile App Testing", link: "/features/mobile-app-testing" },
    { name: "Automated API Testing", link: "/features/api-testing" },
    { name: "Automated Regression Testing", link: "/features/regression-testing" },
    { name: "Automated Data Driven Testing", link: "/features/data-driven-testing" },
    { name: "AI Driven Test Automation", link: "/features/ai-test-automation" },
    { name: "Automated Continuous Testing", link: "/features/continuous-testing" },
    { name: "Automated Visual Testing", link: "/features/visual-testing" },
    { name: "Automated Salesforce Testing", link: "/features/salesforce-testing" },
  ];

  export {
    topFeatures,
    alternativesLinks,
    resourcesLinks,
    guidesLinks,
    communityLinks,
    productLinks,
    aboutLinks,
    topSoftwareTools
  }